<template>
  <div class="wrap1">
    <h1 class="common-title">
      <i class="el-icon-arrow-left back" @click="handlerBack"></i
      >{{ type ? $t('i18n.6c1cc1d76b7742a4bd6a55aa95d134a2') : $t('341') }}
    </h1>
    <div class="wrap1-box wrap1-btn">
      <el-form :model="formData" :rules="rules" ref="formData" class="formData form-box">
        <el-form-item v-if="!type" :label="$t('347')" prop="group_name">
          <el-input :placeholder="$t('90')" v-model="formData.group_name" clearable> </el-input>
        </el-form-item>
        <el-form-item v-else :label="$t('347')" prop="id">
          <el-select
            clearable
            value-key="id"
            class="sel-auth"
            v-model="formData.id"
            :disabled="type === 2"
            :placeholder="$t('221')"
            @change="groupGetInfo(formData.id, true)"
          >
            <el-option
              v-for="item in groupOptions"
              :key="item.value"
              :label="item.group_name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="list-title list-item">
        <span class="list-all">
          <el-checkbox
            :indeterminate="allSelect.inde"
            v-model="allSelect.value"
            @change="handleAllSelect"
          ></el-checkbox>
        </span>
        <span class="list-name">
          {{ $t('i18n.b1db7c03cf8d457d9ee4ab997432d617') }}
        </span>
        <span class="list-edit list-select" v-for="(item, index) in listCheckArr" :key="item.privilege_key">
          <el-checkbox :indeterminate="item.inde" v-model="item.value" @change="handleColumn(item, index)">
            {{ $t('21') }}
          </el-checkbox>
        </span>
      </div>

      <ul class="list">
        <li v-for="parent in recouseList" :key="parent.id">
          <div class="list-item">
            <span class="list-all">
              <el-checkbox
                v-if="parent.isSelect"
                :indeterminate="parent.isSelect.inde"
                v-model="parent.isSelect.value"
                @change="handleParent(parent)"
              ></el-checkbox>
            </span>
            <span class="list-name">
              <i
                @click="handleOpen(parent)"
                :class="[parent.open ? 'el-icon-remove-outline' : 'el-icon-circle-plus-outline', 'icon']"
              ></i>
              {{ parent.name }}
              <!-- {{ parent.id }} -->
            </span>
          </div>
          <ul v-show="parent.open">
            <li class="list-item" v-for="(sub, subIndex) in parent.children" :key="sub.id">
              <span class="list-all">
                <el-checkbox
                  v-if="sub.isSelect"
                  :indeterminate="sub.isSelect.inde"
                  v-model="sub.isSelect.value"
                  @change="handleSub(sub, subIndex, parent)"
                ></el-checkbox>
              </span>
              <span class="list-name">
                {{ sub.name }}
                <!-- {{ sub.id }} -->
              </span>
              <span
                class="list-check list-select"
                v-for="(extend, extendIndex) in sub.extend_privilege"
                :key="extend.privilege_key"
              >
                <template v-if="extend.is_can_setting">
                  <!-- {{ extend.value }} -->
                  <el-checkbox v-model="extend.value" @change="handleItem(extend, extendIndex, sub, subIndex, parent)"
                    >{{ extend.privilege_name }}
                  </el-checkbox>
                  <template v-if="extend.tips">
                    <el-tooltip class="tooltip" effect="dark" :content="extend.tips" placement="top-start">
                      <div>
                        <img class="icon" src="@/assets/img/icon_doubt.png" alt="" />
                      </div>
                    </el-tooltip>
                  </template>
                </template>
                <template v-else>-</template>
              </span>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="flex-btn">
      <div class="left">
        <el-button size="small" @click="handlerDelete" v-if="formData.id && $p('menu.settings.author.delete')">
          {{ $t('65') }}
        </el-button>
      </div>
      <div class="right">
        <el-button size="small" @click="handlerBack"> {{ $t('66') }} </el-button>
        <el-button size="small" type="primary" @click="handleCreate" v-if="$p('menu.settings.author.edit')">
          {{ $t('67') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
// 接口api
import { recouseList, groupList, groupInfo, modifyGroup, createGroup, remove } from 'api/settings'
const formData = () => {
  return {
    id: '',
    group_name: '',
    grant: []
  }
}
const listCheckArr = _this => {
  return [
    {
      inde: false,
      is_can_setting: false,
      privilege_key: 'view',
      privilege_name: _this.$t('64'),
      data: {},
      tips: null,
      value: false
    },
    {
      inde: false,
      is_can_setting: false,
      privilege_key: 'edit',
      privilege_name: _this.$t('71'),
      data: {},
      tips: null,
      value: false
    },
    {
      inde: false,
      is_can_setting: false,
      privilege_key: 'delete',
      privilege_name: _this.$t('65'),
      data: {},
      tips: null,
      value: false
    },
    {
      inde: false,
      is_can_setting: false,
      privilege_key: 'export',
      privilege_name: _this.$t('68'),
      data: {},
      tips: null,
      value: false
    },
    {
      inde: false,
      is_can_setting: false,
      privilege_key: 'setting',
      privilege_name: _this.$t('63'),
      data: {},
      tips: null,
      value: false
    }
  ]
}
const allSelect = _this => {
  return {
    inde: false,
    value: false,
    label: _this.$t('21'),
    viewLen: 0,
    editLen: 0,
    deleteLen: 0,
    exportLen: 0,
    settingLen: 0
  }
}
export default {
  data() {
    return {
      type: this.$route.query.type ? Number(this.$route.query.type) : null,
      groupOptions: [],
      recouseList: [],
      listCheckArr: listCheckArr(this),
      formData: formData(),
      allSelect: allSelect(this),
      rules: {
        id: [{ required: true, message: this.$t('820'), trigger: ['change'] }],
        group_name: [{ required: true, message: this.$t('820'), trigger: ['blur'] }]
      }
    }
  },
  async created() {
    await this.getRecouseList()
    if (this.type) await this.groupGetList()
  },
  methods: {
    setStatus(val) {
      if (val.ever) {
        val.item.value = true
        val.item.inde = false
      } else if (val.some) {
        val.item.value = false
        val.item.inde = true
      } else {
        val.item.inde = false
        val.item.value = false
      }
    },
    handleItem(extend, extendIndex, sub, subIndex, parent) {
      this.handleItemStatus(sub)
      this.handleParentStatus(parent)
      this.handleRowStatus()
      this.handleAllStatus()
    },
    handleSub(sub, subIndex, parent) {
      if (sub.isSelect.inde) {
        sub.isSelect.inde = false
        sub.isSelect.value = true
      }
      sub.extend_privilege.forEach(extend => {
        if (extend.is_can_setting) {
          extend.value = sub.isSelect.value
        }
      })
      this.handleParentStatus(parent)
      this.handleRowStatus()
      this.handleAllStatus()
    },
    handleParent(parent) {
      if (parent.isSelect.inde) {
        parent.isSelect.inde = false
        parent.isSelect.value = true
      }
      if (parent.children && parent.children.length) {
        parent.children.forEach((sub, subIndex) => {
          sub.isSelect.inde = false
          sub.isSelect.value = parent.isSelect.value
          sub.extend_privilege.forEach(extend => {
            if (extend.is_can_setting) {
              extend.value = sub.isSelect.value
            }
          })
        })
      }
      this.handleRowStatus()
      this.handleAllStatus()
    },
    // item状态
    handleItemStatus(sub) {
      // 没有需要设置的项 直接返回
      if (sub.is_extend) {
        return
      }
      // 子元素全选状态
      const subEvery = sub.extend_privilege.filter(item => {
        if (item.is_can_setting) return item.value
      })
      const subSome = sub.extend_privilege.some(item => {
        if (item.is_can_setting) return item.value
      })
      this.setStatus({
        ever: subEvery.length && subEvery.length === sub.extendLen,
        some: subSome,
        item: sub.isSelect
      })
    },
    // 父元素全选状态
    handleParentStatus(parent) {
      const parentEvery = parent.children.every(child => {
        return child.isSelect.value
      })
      const parentSome = parent.children.some(child => {
        return child.isSelect.value || child.isSelect.inde
      })
      this.setStatus({ ever: parentEvery, some: parentSome, item: parent.isSelect })
    },
    // 列全选状态
    handleRowStatus() {
      console.log(this.listCheckArr)
      this.listCheckArr.forEach(item => {
        const keys = Object.keys(item.data)
        const some = keys.some(key => {
          return item.data[key].value
        })
        const ever = keys.every(key => {
          return item.data[key].value
        })
        this.setStatus({ ever: ever, some: some, item })
      })
    },
    // 所有全选状态
    handleAllStatus() {
      const allSome = this.recouseList.some(item => {
        return item.isSelect.value || item.isSelect.inde
      })
      const alleEvery = this.recouseList.every(item => {
        return item.isSelect.value
      })
      this.setStatus({ ever: alleEvery, some: allSome, item: this.allSelect })
    },
    handleColumnStatus(extend, index) {
      this.recouseList.forEach(parent => {
        parent.children.forEach(sub => {
          const item = sub.extend_privilege[index]
          if (item.is_can_setting) {
            item.value = extend.value
          } else {
          }
          this.handleItemStatus(sub)
        })
        this.handleParentStatus(parent)
      })
      this.handleAllStatus()
    },
    // 点击列的全选
    handleColumn(extend, index) {
      if (extend.inde) {
        this.$confirm(this.$t('ask-select-all'), this.$t('229'), {
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          type: 'warning'
        })
          .then(() => {
            extend.value = true
            extend.inde = false
            this.handleColumnStatus(extend, index)
          })
          .catch(() => {})
      } else {
        this.handleColumnStatus(extend, index)
      }
    },
    handleAllSelect() {
      if (this.allSelect.inde) {
        this.allSelect.value = true
        this.allSelect.inde = false
      }
      this.listCheckArr.forEach(item => {
        item.value = this.allSelect.value
        item.inde = false
      })
      this.handleData(this.recouseList, 'all')
    },
    handleData(data, type) {
      const list = []
      if (!type) this.allSelect = allSelect(this)
      data.forEach(item => {
        item.isSelect = { label: this.$t('21'), inde: false, value: this.allSelect.value }
        item.type = item.id
        item.open = true
        list.push(item)
        item.children.forEach(child => {
          child.isSelect = { label: this.$t('21'), inde: false, value: this.allSelect.value }
          child.extend = {}
          if (!child.extend_privilege.length) {
            child.extend_privilege = listCheckArr(this)
            child.is_extend = true
          }
          child.extend_privilege.forEach((extend, index) => {
            const checkItem = this.listCheckArr[index] || {}
            extend.inde = false
            extend.value = this.allSelect.value
            if (extend.is_can_setting) {
              checkItem.data[child.id] = extend
              // 设置每个类型的个数
              this.allSelect[extend.privilege_key + 'Len'] += 1
              child.extend[extend.privilege_key] = extend
            }
          })
          const extend = child.extend_privilege.filter(extend => extend.is_can_setting)
          child.paren_id = item.id
          child.type = item.id + '_' + child.id
          child.extendLen = extend.length
          list.push(child)
        })
      })
      this.recouseList = data
    },
    handleCreate() {
      // 权限数组
      let api = createGroup
      let query = {
        group_name: this.formData.group_name,
        grant: []
      }
      this.recouseList.forEach(parent => {
        parent.children.forEach(item => {
          if (item.isSelect.inde || item.isSelect.value) {
            const obj = {
              resource_id: item.id,
              view: false,
              edit: false,
              delete: false,
              export: false,
              setting: false
            }
            item.extend_privilege.forEach(extend => {
              if (extend.privilege_key) obj[extend.privilege_key] = extend.value || false
            })
            query.grant.push(obj)
          }
        })
      })
      if (this.type) {
        api = modifyGroup
        query = {
          grant: query.grant,
          group_id: this.formData.id
        }
      }
      this.$refs.formData.validate(valid => {
        if (valid) {
          api(query).then(() => {
            this.$message.success(this.$t('818'))
            this.handlerBack()
          })
        }
      })
    },
    // 获取权限资源列表
    async getRecouseList() {
      const { data } = await recouseList()
      this.handleData(data)
    },
    // 获取组数据
    groupGetList() {
      groupList()
        .then(({ data }) => {
          this.groupOptions = data || []
          const group_id = this.groupOptions[0]?.id || ''
          this.formData.id = this.$route.query.group_id || group_id
          this.groupGetInfo()
        })
        .catch(() => {
          this.groupOptions = []
          this.formData.id = this.$route.query.group_id || ''
          this.groupGetInfo()
        })
    },
    // 获取组下面列表数据
    async groupGetInfo() {
      this.formData.grant = []
      this.allSelect.value = false
      this.allSelect.inde = false
      this.handleAllSelect()
      this.listCheckArr = listCheckArr(this)
      if (this.formData.id) {
        const { data } = await groupInfo({ group_id: this.formData.id })
        this.recouseList.forEach(parent => {
          parent.children.forEach(sub => {
            data.grant.forEach(item => {
              if (Number(item.resource_id) === Number(sub.id)) {
                if (sub.extendLen) {
                  sub.extend_privilege.forEach((extend, index) => {
                    const key = extend.privilege_key
                    if (extend.is_can_setting) extend.value = item[key]
                    else extend.value = false
                  })
                  this.handleItemStatus(sub)
                } else {
                  sub.isSelect.value = true
                }
              }
            })
            sub.extend_privilege.forEach((extend, index) => {
              const checkItem = this.listCheckArr[index] || {}
              if (extend.is_can_setting) checkItem.data[sub.id] = extend
            })
          })
          this.handleParentStatus(parent)
        })
        this.handleRowStatus()
        this.handleAllStatus()
        this.formData = data
      }
    },
    // 删除权限组
    handlerDelete() {
      this.$confirm(this.$t('ask-delete-group'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      })
        .then(() => {
          remove({ group_id: this.formData.id }).then(() => {
            this.handlerBack()
          })
        })
        .catch(() => {})
    },
    handlerBack() {
      this.$router.push('/settings/author/authors')
    },
    // 展开 关闭
    handleOpen(row) {
      row.open = !row.open
      this.recouseList.forEach(item => {
        if (row.id === item.paren_id) item.show = row.open
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-input {
  width: 40%;
  max-width: 40%;
  min-width: 200px;
}
.el-select {
  width: 40%;
  /deep/.el-input {
    width: 100%;
    max-width: 100%;
  }
}
.list {
  &-title {
    color: #8c8c8c;
    background-color: #f5f6f9;
  }
  &-item {
    display: flex;
    padding: 0 24px;
    font-size: 14px;
    line-height: 44px;
    border-bottom: 1px solid #ebeef5;
    span {
      flex: 1;
      display: flex;
    }
    color: #262626;
    .list-name {
      padding-left: 20px;
      position: relative;
      .icon {
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -7px;
        cursor: pointer;
      }
    }
  }
  &-all {
    max-width: 50px;
  }
  &-name {
    min-width: 180px;
  }
  &-select {
    min-width: 100px;
  }
}
.flex-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 48px;
}
.icon {
  width: 16px;
  vertical-align: middle;
  margin-top: -3px;
  margin-left: 5px;
}
</style>
